import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./UserLandingPage.css";

function UserLandingPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const user = location.state?.user || {};
  const [voucherCount, setVoucherCount] = useState(user.voucher_count || 0);

  useEffect(() => {
    if (!user.user_id) {
      navigate("/");
    } else {
      fetch(`/api/user-vouchers-count/${user.user_id}`)
        .then((res) => res.json())
        .then((data) => {
          if (data.success) {
            setVoucherCount(data.voucher_count);
          }
        })
        .catch((err) => console.error("Error fetching voucher count:", err));
    }
  }, [user, navigate]);

  return (
    <div className="user-landing-page">
      <h2 className="username">{user.first_name}</h2>

      {/* Loyalty Card */}
      <div className="card loyalty">
        <div className="card-content">
          <span className="card-title">Loyalty</span>
          <span className="card-value">{user?.loyalty_points || 0}</span>
        </div>
      </div>

      {/* Vouchers Card */}
      <div className="card vouchers" onClick={() => navigate(`/user/${user.hash}/vouchers`, { state: { user } })}>
        <div className="card-content">
          <span className="card-title">Vouchers</span>
          <span className="card-value">{voucherCount}</span>
        </div>
      </div>

      {/* Cashback Card */}
      <div className="card cashback">
        <div className="card-content">
          <span className="card-title">Cashback</span>
          <span className="card-subtitle">Lifetime earnings</span>
          <span className="card-value">${user?.cashback_earned || "0.00"}</span>
        </div>
        <div className="redeem-section">
          <span className="redeem-text">Available to redeem</span>
          <span className="redeem-amount">${user?.cashback_available || "0.00"}</span>
          <button className="redeem-button">Redeem</button>
        </div>
      </div>

      {/* Extra Buttons Section */}
      <div className="extra-buttons">
        <div className="button-row">
          <div className="button-item" onClick={() => navigate("/promos")}>
            <i className="icon promos-icon"></i>
            <span>Promos</span>
          </div>
          <div className="button-item" onClick={() => navigate(`/user/${user.hash}/transactions`, { state: { user } })}>
            <i className="icon transactions-icon"></i>
            <span>Transactions</span>
          </div>
        </div>
        <div className="button-row">
          <div className="button-item" onClick={() => navigate("/referrals")}>
            <i className="icon referrals-icon"></i>
            <span>Referrals</span>
          </div>
          <div className="button-item" onClick={() => navigate("/watchlist")}>
            <i className="icon watchlist-icon"></i>
            <span>Watchlist</span>
          </div>
        </div>
        <div className="button-row">
          <div className="button-item" onClick={() => navigate("/rewards")}>
            <i className="icon rewards-icon"></i>
            <span>Rewards</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserLandingPage;
